import React from "react";
import styled from "styled-components";
import { Footer, footerOptions, optionsFor } from "@pga/pga-component-library";
import { withAuthProvider } from "../../lib/auth";

export const FooterContainer = styled.div`
  text-align: left;
`;

const sanitizeSections = (sections) =>
  sections.map((section) => ({
    ...section,
    options: Array.isArray(section.options)
      ? section.options.map((option) =>
          option.link === "javascript:void(0)"
            ? { ...option, link: "#" }
            : option,
        )
      : section.options,
  }));

export const JobsFooter = ({ isLoggedIn, me }) => (
  <FooterContainer>
    <Footer
      sections={sanitizeSections(optionsFor(me))}
      copyright={footerOptions.copyrightMessage}
    />
  </FooterContainer>
);

export default withAuthProvider(JobsFooter);
